import React from "react";
import { Button } from "reactstrap";
import "./style.css";

const BlueButton = ({ className = "", label, isDonationMode, ...props }) => {
  return (
    <Button
      {...props}
      className={`blue-button text-capitalize text-white-color backgroundBlurBtn ${className} ${
        isDonationMode
          ? "blue-button--donor border-donor-color bg-donor-color"
          : "blue-button--contractor border-blue-color bg-blue-color"
      }`}
    >
      {label}
    </Button>
  );
};
const GreyButton = ({ className = "", label, ...props }) => {
  return (
    <Button
      {...props}
      className={`text-capitalize  text-blue-color backgroundBlurBtn ${className} border-grey-color bg-grey-color`}
      style={{ borderRadius: "8px" }}
    >
      {label}
    </Button>
  );
};

export default BlueButton;
export { GreyButton };
